import { fetchCatalogsIfNeeded, getCatalog } from '@/redux/modules/catalog';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchCatalogDetailsIfNeeded } from '@/redux/modules/catalogDetail';
import { fetchSellersIfNeeded } from '@/redux/modules/seller';
import { getIdFromPath } from '@/utils/urls';

export default ({ location, store }: DataLoaderParams) => {
    const { dispatch, getState } = store;
    const { pathname } = location;
    const catalogId = getIdFromPath(pathname);
    return Promise.all([
        dispatch(fetchCatalogsIfNeeded([catalogId])),
        dispatch(fetchCatalogDetailsIfNeeded([catalogId])),
    ]).then(() => {
        const state = getState();
        const catalog = getCatalog(state, catalogId);

        return Promise.all([dispatch(fetchSellersIfNeeded([catalog.sellerId]))]);
    });
};
